type IconProps = React.ComponentProps<'svg'>

export function TerminalIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.25, 4.25)">
        <path
          d="M16.7499 13.9999C17.1641 14 17.4999 14.3357 17.4999 14.7499C17.4999 15.1641 17.1641 15.4999 16.7499 15.4999H8.74994C8.33575 15.4999 7.99997 15.1641 7.99994 14.7499C7.99994 14.3357 8.33573 13.9999 8.74994 13.9999H16.7499Z"
          fill="currentColor"
        />
        <path
          d="M0.21967 0.21967C0.512563 -0.0732232 0.987324 -0.0732233 1.28022 0.21967L7.28022 6.21967C7.57305 6.51257 7.57309 6.98734 7.28022 7.28022L1.28022 13.2802C0.987343 13.5731 0.512568 13.5731 0.21967 13.2802C-0.0732233 12.9873 -0.0732233 12.5126 0.21967 12.2197L5.6894 6.74994L0.21967 1.28022C-0.0732233 0.987323 -0.0732233 0.512563 0.21967 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
